import styled from 'styled-components';
import {GrAddCircle} from 'react-icons/gr';
export const ListaDePosts = styled.div`
    display:flex;
    flex-direction:row;
    width:100vw;
    flex-wrap:wrap;
    justify-content:flex-start;
    @media(max-width:800px){
        align-items:center;
        justify-content:center;


    }
`;

export const ImgPost = styled.img`
    width:300px;
    height:300px;
    margin:10px 20px;
    @media(max-width:800px){
        margin:0 0 20px 0;
    }
`
export const DivNovoPost = styled.div`
    width:300px;
    height:300px;
    margin:10px 20px;
    display:flex;
    flex-direction:column;
    align-items:center;
    padding:40px 0 0 0;
    border:1px solid lightgray;
    @media(max-width:800px){
        margin:0 0 20px 0;
    }
`
export const DivMyPosts = styled.div`
    height:calc(100% - 60px);
    overflow:hidden auto;
    padding:20px;
    @media(max-width:800px){
        padding:5px;
    }
`
export const DivPosts = styled.div`
    transition:.5s;
    :hover{
        transform:scale(1.12);
        transition:.5s;
    }
`
export const IconGrAddCircle = styled(GrAddCircle)`
    font-size:60px;
    margin:40px 0 0 0;
`
